import React from 'react'

import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import FormRow from "../../../../../gd-form/form/form-ui5/form-row"
import Input from "../../../../../gd-form/form-element/input/input"
import FormError from "../../../../../gd-form/common/form-error/form-error"
// @ts-ignore
import CustomField_FormRowAccess from "../../../../../fields/custom/common/form-access-new"
// @ts-ignore
import CustomFieldActions from "../../../../../fields/custom/common/form-actions"
// @ts-ignore
import ToggleForm from 'core/gd-form/form-element/toggle-new/toggle'
import {EntityType} from "../../../../../gd/const/item"
import FormTextArea from "../../../../../gd-form/form-element/textarea/textarea"
import FieldProto from "../../../field-proto"

type Props = {
    parent          : any
    entity?         : EntityType
    isNew?          : boolean
    disableRequired?: boolean
    field           : FieldProto

    children?       : any
}

export default function FieldManagementRightPanel(props:Props) {

    let defaultTitle, showAccessField, showDescriptionField

    switch (props.entity) {
        case EntityType.FORM:
            defaultTitle            = 'New form field'
            showAccessField         = false
            showDescriptionField    = true
            break

        default             :
            defaultTitle            = 'New custom field'
            showAccessField         = true
            showDescriptionField    = false
    }

    const title = !props.isNew ? props.field.label : defaultTitle;

    return (
        <div className="iv-cf-form">
            <VScroll className="iv-cf-scroll">

                <div className="iv-header header-left header-small-no-separator">
                    <div className="title-line">
                        <div className="view-name">
                            <div className="ui5-title-app-name max-w-350 ">{title}</div>
                        </div>
                    </div>
                </div>

                <div className="iv-content with-left-panel">
                    <div className="p-l-30">
                        <div className="ui5-form size-30-70">
                            <div className="f-tbl">

                                <FormRow label="Name">
                                    <Input size="big" form={props.parent.form} name="label"/>
                                    <FormError form={props.parent.form} name="label" />
                                </FormRow>

                                {showDescriptionField &&
                                    <FormRow label="Description">
                                        <FormTextArea className = "field-description"
                                                      size      = "big"
                                                      rows      = {2}
                                                      form      = {props.parent.form}
                                                      name      = "description" />
                                        <FormError className    = "w-300"
                                                   form         = {props.parent.form}
                                                   name         = "description"/>
                                    </FormRow>}

                                {showAccessField && <CustomField_FormRowAccess form={props.parent.form}/>}

                                <FormRow label="Is required">
                                    <ToggleForm size="20" form={props.parent.form} name="isRequired" disabled={props.disableRequired}/>
                                    <FormError form={props.parent.form} name="isRequired" />
                                </FormRow>

                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </VScroll>

            <CustomFieldActions form={props.parent.form}/>
        </div>
    );
}
